
import echarts from "echarts"
import { computed, nextTick, watch } from "vue"

export default {
  props: {
    list: {
      type: Array
    }
  },
  setup() {
    const option = computed(() => {
      return {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          bottom: "0",
          orient: "horizontal",
          textStyle: {
            color: "rgba(255, 255, 255, .75)"
          },
          data: ["差", "一般", "良好", "优秀"]
        },
        series: [
          {
            name: "睡眠质量",
            type: "pie",
            radius: "55%",
            center: ["50%", "45%"],
            data: [
              { value: 3297, name: "差" },
              { value: 3447, name: "一般" },
              { value: 2775, name: "良好" },
              { value: 1040, name: "优秀" }
            ],
            label: {
              color: "#fff",
              formatter: (value: { percent: number }) => {
                return value.percent + "%"
              }
            },
            color: ["#18396e", "#1f4a8f", "#275cb1", "#2f6dd2"],
            // color: [
            //   "rgb(107, 250, 185,.84)",
            //   "rgb(107, 204, 249,.72)",
            //   "rgb(250, 203, 87,.72)",
            //   "rgb(255, 66, 84,.72)"
            // ],
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function() {
              return Math.random() * 200
            }
          }
        ]
      }
    })
    let ref: HTMLDivElement
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let echartsDom: echarts.ECharts
    const setRef = (el: HTMLDivElement) => (ref = el)
    nextTick(() => {
      echartsDom = echarts.init(ref)
      echartsDom.setOption(option.value as echarts.EChartOption)
    })
    watch(
      () => option.value,
      (val) => {
        echartsDom?.setOption(val as echarts.EChartOption)
      }
    )
    return { setRef }
  }
}
